import React from 'react';
import {Route, Switch} from 'react-router-dom';

import ROUTE_PATHS from '@/consts/route/routePaths';
import useWithLocale from '@/hooks/useWithLocale';

import ConnectionGuidePage from './ConnectionGuidePage/ConnectionGuidePage';
import ConnectionPage from './ConnectionPage/ConnectionPage';

const ConnectionPageRoutes = () => {
    const withLocale = useWithLocale();

    return (
        <Switch>
            <Route path={withLocale(ROUTE_PATHS.CONNECTION_GUIDE_PARAMETERIZED)} component={ConnectionGuidePage} />
            <Route path={withLocale(ROUTE_PATHS.CONNECTION_CONNECT_PARAMETERIZED)} component={ConnectionPage} />
        </Switch>
    );
};

export default ConnectionPageRoutes;
